import styled from 'styled-components'
import { Skeleton } from '~/components/shared'
import { VerticalStyledScrollBar } from '~/styles'

export const HeaderContainer = styled.header`
  position: relative;
  width: 100%;
  padding: 0 1.5rem 1rem 1.5rem;

  border-bottom: 1px solid ${props => props.theme.colors.colorDCE3ED};

  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const Title = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: ${props => props.theme.colors.color2d3139};
`

export const Subtitle = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  color: ${props => props.theme.colors.color545e6c};
`

export const ContentContainer = styled.section`
  position: relative;
  width: 100%;
  margin-top: 2rem;
  padding: 0 1rem 2rem 1.5rem;

  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ContentLabel = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: ${props => props.theme.colors.color122d52};
`

export const ActivitiesList = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  position: relative;
  width: 100%;
  /* sun of margin's + padding's + height of containers above the ActivitiesList */
  height: calc(100vh - 207px);
  padding-right: 1rem;

  display: grid;
  grid-auto-rows: 72px;
  row-gap: 0.75rem;

  overflow: auto;

  ${VerticalStyledScrollBar}
`

export const SkeletonList = styled(Skeleton).attrs({
  width: '90%',
  height: '72px',
  count: 7
})`
  position: relative;
  display: grid;
  row-gap: 0.75rem;
`
